import { render, staticRenderFns } from "./creationApply.vue?vue&type=template&id=10d96874&"
import script from "./creationApply.vue?vue&type=script&lang=js&"
export * from "./creationApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports